<template>
  <select
    class="form-select"
    :class="[sizeClass, customClass]"
    :value="modelValue"
    @change="$emit('update:modelValue', $event.target.value)"
    :disabled="disabled"
  >
    <option v-if="placeholder" value="" :disabled="placeholderDisabled">
      {{ placeholder }}
    </option>
    <option
      v-for="option in normalizedOptions"
      :key="option.value"
      :value="option.value"
    >
      {{ option.label }}
    </option>
  </select>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  options: {
    type: Array,
    required: true
    // Can be array of strings: ['Option 1', 'Option 2']
    // Or array of objects: [{ value: 'opt1', label: 'Option 1' }]
  },
  placeholder: {
    type: String,
    default: ''
  },
  placeholderDisabled: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: '',
    validator: (value) => ['', 'sm', 'lg'].includes(value)
  },
  disabled: {
    type: Boolean,
    default: false
  },
  customClass: {
    type: String,
    default: ''
  }
});

defineEmits(['update:modelValue']);

const sizeClass = computed(() => props.size ? `form-select-${props.size}` : '');

const normalizedOptions = computed(() => {
  return props.options.map(option => {
    if (typeof option === 'object' && option !== null) {
      return {
        value: option.value ?? option.id ?? option.key,
        label: option.label ?? option.name ?? option.text ?? option.value
      };
    }
    return { value: option, label: option };
  });
});
</script>
